import { render, staticRenderFns } from "./LanguageChooser.vue?vue&type=template&id=6d4a7982&scoped=true"
import script from "./LanguageChooser.vue?vue&type=script&lang=js"
export * from "./LanguageChooser.vue?vue&type=script&lang=js"
import style0 from "./LanguageChooser.vue?vue&type=style&index=0&id=6d4a7982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4a7982",
  null
  
)

export default component.exports